import React from 'react'
import SearchPage from './SearchPage'
import '../style/user-admin.scss'
import UserAdminPage from './UserAdminPage'
import CreateServiceAccountForm from '../containers/CreateServiceAccountForm'
import { userHasRole } from 'app/utils/userUtils'

const UserAdmin = ({ user, userId, searchForUsers, userAdmin, stationList, location, fetchUser, fetchUserEvents, updateUser, updateUserAffiliations }) =>
  // UserAdmin accepts and passes the location prop so that when the location changes, React knows to re-render UserAdminPage since React re-renders on prop change
  <div className='user-admin'>
    {userId
      ? <UserAdminPage
        userId={userId}
        location={location}
        user={userAdmin.users[userId] || {}}
        stationList={stationList}
        fetchUser={fetchUser}
        fetchUserEvents={fetchUserEvents}
        updateUser={updateUser}
        updateUserAffiliations={updateUserAffiliations} />
      : <div>
        <SearchPage searchForUsers={searchForUsers} search={userAdmin.search} />
        {/*TODO: Check functionality, not role */userHasRole(user, 'API Admin') && <CreateServiceAccountForm />}
      </div>
    }
  </div>

export default UserAdmin